import React, { useState, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { AnalyticsEvent } from "../../components/elements/analytics-event";

const IncentiveOverlay = (props) => {
  const timerVal = useRef(0);
  const first = useRef(0);
  const loadOut = useRef(0);
  const loadIn = useRef(0);

  const [load, setLoad] = useState("");

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/rewards/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    const urlParams = new URLSearchParams(queryString);
    const fake = urlParams.get("fake") ? urlParams.get("fake") : "no";
    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(
        streamType,
        username,
        slug,
        null,
        fake === "yes"
      );

      return () => props.overlayStore.socketDisconnect();
    }
  }, []);

  useEffect(() => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const fake = urlParams.get("fake") ? urlParams.get("fake") : "no";
    const timer = urlParams.get("timer") || "0";
    if (["5", "10", "15"].includes(timer)) {
      timerVal.current = parseInt(timer) * 60000;
    } else {
      timerVal.current = 300000;
    }

    timer === "0"
      ? setLoad("load-in")
      : (first.current = setTimeout(() => start(), 3000));

    return () => {
      clearTimeout(first.current);
      clearTimeout(loadOut.current);
      clearTimeout(loadIn.current);
    };
  }, []);

  const start = () => {
    setLoad("load-in");
    let items = document.querySelectorAll(".rewards-list li"),
      i;
    for (i = 0; i < items.length; i++) {
      items[i].style.animationDelay = [i] * 0.3 + "s";
    }

    loadOut.current = setTimeout(() => stop(), 60000);
  };

  const stop = () => {
    setLoad("load-out");
    let items = document.querySelectorAll(".rewards-list li"),
      i;
    for (i = 0; i < items.length; i++) {
      const listNum = document.querySelectorAll(".rewards-list li").length;
      items[i].style.animationDelay = (listNum - [i]) * 0.3 + "s";
    }

    loadIn.current = setTimeout(() => start(), timerVal.current);
    console.log(timerVal.current);
  };

  const { rewardSort } = props.overlayStore;

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const bgColor = urlParams.get("bgColor");
  const quantity = urlParams.get("quantity");
  const align = urlParams.get("align");
  const type = urlParams.get("type");
  const rewards = urlParams.get("rewards");
  const highlighted = urlParams.get("highlighted");

  return (
    <div>
      <div className="incentive-overlay">
        {AnalyticsEvent("english", "/", "PLAY LIVE Incentive Overlay")}
        <ul
          id="rewards-list"
          className={"rewards-list left " + load + " " + type}
        >
          <li>
            <div className={"title " + bgColor}>
              <span>My Donation Rewards</span>
            </div>
          </li>
          {/* {rewards[0].active && <li className="recent-dono">Rewards</li>} */}
          {/* {rewards.map((reward) => (
              <li key={reward.id} className={bgColor}>
                  <span>${addZeroes(reward.amount)}</span>{" "}
                  <span>{reward.name}</span>{" "}
              </li>
            ))}     */}
          {highlighted === "yes"
            ? rewardSort.map(
                (reward) =>
                  reward.active === true &&
                  reward.highlighted === true && (
                    <li key={reward.id}>
                      <div className="amount highlighted">
                        <span>
                          ${formatNumber(Number(reward.amount.value))}
                        </span>
                      </div>
                      <div className={"text highlighted " + `${bgColor}`}>
                        <span>{reward.name} </span>
                        {quantity === "yes" ? (
                          reward.quantity > 0 ? (
                            <span className="quantity">
                              {formatNumber(
                                Number(
                                  reward.quantity - reward.quantity_remaining
                                )
                              ) +
                                "/" +
                                reward.quantity}
                            </span>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="stars">
                        {/* <img className="star" src={star} />
                        <img className="star" src={star} />
                        <img className="star" src={star} /> */}
                        <div className="star"></div>
                        <div className="star"></div>
                        <div className="star"></div>
                      </div>
                    </li>
                  )
              )
            : ""}

          {rewards === "yes" && highlighted === "yes"
            ? rewardSort.map(
                (reward) =>
                  reward.active === true &&
                  reward.highlighted === false && (
                    <li key={reward.id}>
                      <div className="amount">
                        <span>
                          ${formatNumber(Number(reward.amount.value))}
                        </span>
                      </div>
                      <div className={"text " + `${bgColor}`}>
                        <span>{reward.name} </span>
                        {quantity === "yes" ? (
                          reward.quantity > 0 ? (
                            <span className="quantity">
                              {formatNumber(
                                Number(
                                  reward.quantity - reward.quantity_remaining
                                )
                              ) +
                                "/" +
                                reward.quantity}
                            </span>
                          ) : (
                            ""
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </li>
                  )
              )
            : ""}

          {rewards === "yes" && highlighted === "no"
            ? rewardSort.map(
                (reward) =>
                  reward.active === true && (
                    <li key={reward.id}>
                      <div className="amount">
                        <span>
                          ${formatNumber(Number(reward.amount.value))}
                        </span>
                      </div>
                      <div className={"text " + `${bgColor}`}>
                        <span>
                          {reward.name}{" "}
                          {quantity === "yes"
                            ? reward.quantity > 0
                              ? formatNumber(
                                  Number(
                                    reward.quantity - reward.quantity_remaining
                                  )
                                ) +
                                "/" +
                                reward.quantity
                              : ""
                            : ""}
                        </span>
                      </div>
                    </li>
                  )
              )
            : ""}
          {/* {rewardSort.map(
            (reward) =>
              reward.active === true && (
                <li key={reward.id} className={bgColor}>
                  <span>${formatNumber(Number(reward.amount.value))} -</span>{" "}
                  <span>
                    {reward.name}{" "}
                    {quantity === "yes"
                      ? reward.quantity > 0
                        ? formatNumber(
                            Number(reward.quantity - reward.quantity_remaining)
                          ) +
                          "/" +
                          reward.quantity
                        : ""
                      : ""}
                  </span>{" "}
                </li>
              )
          )} */}
        </ul>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(IncentiveOverlay));
